/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NodataDiscardBillResVo } from './NodataDiscardBillResVo';
import {
    NodataDiscardBillResVoFromJSON,
    NodataDiscardBillResVoFromJSONTyped,
    NodataDiscardBillResVoToJSON,
    NodataDiscardBillResVoToJSONTyped,
} from './NodataDiscardBillResVo';

/**
 * 
 * @export
 * @interface NodataPageItemResVo
 */
export interface NodataPageItemResVo {
    /**
     * 无数据编号
     * @type {number}
     * @memberof NodataPageItemResVo
     */
    id?: number;
    /**
     * 仓库ID
     * @type {number}
     * @memberof NodataPageItemResVo
     */
    warehouseId?: number;
    /**
     * 仓库名称（按当前语言）
     * @type {string}
     * @memberof NodataPageItemResVo
     */
    warehouseName?: string;
    /**
     * 实拍图片 URL（按快递单号从 OrderFileAppService 取，nodata 表 image_url 不再使用）
     * @type {string}
     * @memberof NodataPageItemResVo
     */
    imageUrl?: string;
    /**
     * 会员编号（user_account）
     * @type {string}
     * @memberof NodataPageItemResVo
     */
    userCode?: string;
    /**
     * 会员名（来自 person.user）
     * @type {string}
     * @memberof NodataPageItemResVo
     */
    userName?: string;
    /**
     * 快递单号
     * @type {string}
     * @memberof NodataPageItemResVo
     */
    trackingNumber?: string;
    /**
     * 货位号
     * @type {string}
     * @memberof NodataPageItemResVo
     */
    locationNo?: string;
    /**
     * 数量
     * @type {number}
     * @memberof NodataPageItemResVo
     */
    quantity?: number;
    /**
     * 到付运费
     * @type {number}
     * @memberof NodataPageItemResVo
     */
    carriageForward?: number;
    /**
     * Coupang入库码（仅韩国返送/废弃使用）
     * @type {string}
     * @memberof NodataPageItemResVo
     */
    coupangInboundCode?: string;
    /**
     * 订单编号列表：中国取 nodata.match_order_codes；韩国取 nodata.rocket_order_code（单号）
     * @type {Array<string>}
     * @memberof NodataPageItemResVo
     */
    orderCodes?: Array<string>;
    /**
     * 操作员
     * @type {string}
     * @memberof NodataPageItemResVo
     */
    operatorName?: string;
    /**
     * 无数据类型（NodataTypeEnum: 1=一般 2=返送 3=废弃）
     * @type {number}
     * @memberof NodataPageItemResVo
     */
    nodataType?: number;
    /**
     * 无数据类型名称（按当前语言）
     * @type {string}
     * @memberof NodataPageItemResVo
     */
    nodataTypeName?: string;
    /**
     * 无数据状态（NodataStatusEnum: 1未匹配 2已匹配 3最终完成 4废弃）
     * @type {number}
     * @memberof NodataPageItemResVo
     */
    nodataStatus?: number;
    /**
     * 无数据状态名称（按当前语言）
     * @type {string}
     * @memberof NodataPageItemResVo
     */
    nodataStatusName?: string;
    /**
     * 是否返送订单 0/1（仅韩国）
     * @type {number}
     * @memberof NodataPageItemResVo
     */
    returnFromCoupang?: number;
    /**
     * 登记时间
     * @type {string}
     * @memberof NodataPageItemResVo
     */
    createTime?: string;
    /**
     * 废弃日期（仅废弃Tab有值；当前以 updateTime 近似，待业务确认是否新增专门字段）
     * @type {string}
     * @memberof NodataPageItemResVo
     */
    discardTime?: string;
    /**
     * 
     * @type {NodataDiscardBillResVo}
     * @memberof NodataPageItemResVo
     */
    discardBill?: NodataDiscardBillResVo;
    /**
     * 是否显示【废弃】按钮：仅当未匹配状态
     * @type {boolean}
     * @memberof NodataPageItemResVo
     */
    showDiscardBtn?: boolean;
    /**
     * 是否显示【删除】按钮：未匹配 或 已废弃
     * @type {boolean}
     * @memberof NodataPageItemResVo
     */
    showDelBtn?: boolean;
    /**
     * 是否显示【匹配】按钮：仅未匹配状态
     * @type {boolean}
     * @memberof NodataPageItemResVo
     */
    showMatchBtn?: boolean;
    /**
     * 是否显示【解除匹配】按钮：已匹配且关联订单尚未全部完成
     * @type {boolean}
     * @memberof NodataPageItemResVo
     */
    showUnMatchBtn?: boolean;
}

/**
 * Check if a given object implements the NodataPageItemResVo interface.
 */
export function instanceOfNodataPageItemResVo(value: object): value is NodataPageItemResVo {
    return true;
}

export function NodataPageItemResVoFromJSON(json: any): NodataPageItemResVo {
    return NodataPageItemResVoFromJSONTyped(json, false);
}

export function NodataPageItemResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NodataPageItemResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'warehouseId': json['warehouseId'] == null ? undefined : json['warehouseId'],
        'warehouseName': json['warehouseName'] == null ? undefined : json['warehouseName'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'userCode': json['userCode'] == null ? undefined : json['userCode'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'trackingNumber': json['trackingNumber'] == null ? undefined : json['trackingNumber'],
        'locationNo': json['locationNo'] == null ? undefined : json['locationNo'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'carriageForward': json['carriageForward'] == null ? undefined : json['carriageForward'],
        'coupangInboundCode': json['coupangInboundCode'] == null ? undefined : json['coupangInboundCode'],
        'orderCodes': json['orderCodes'] == null ? undefined : json['orderCodes'],
        'operatorName': json['operatorName'] == null ? undefined : json['operatorName'],
        'nodataType': json['nodataType'] == null ? undefined : json['nodataType'],
        'nodataTypeName': json['nodataTypeName'] == null ? undefined : json['nodataTypeName'],
        'nodataStatus': json['nodataStatus'] == null ? undefined : json['nodataStatus'],
        'nodataStatusName': json['nodataStatusName'] == null ? undefined : json['nodataStatusName'],
        'returnFromCoupang': json['returnFromCoupang'] == null ? undefined : json['returnFromCoupang'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'discardTime': json['discardTime'] == null ? undefined : json['discardTime'],
        'discardBill': json['discardBill'] == null ? undefined : NodataDiscardBillResVoFromJSON(json['discardBill']),
        'showDiscardBtn': json['showDiscardBtn'] == null ? undefined : json['showDiscardBtn'],
        'showDelBtn': json['showDelBtn'] == null ? undefined : json['showDelBtn'],
        'showMatchBtn': json['showMatchBtn'] == null ? undefined : json['showMatchBtn'],
        'showUnMatchBtn': json['showUnMatchBtn'] == null ? undefined : json['showUnMatchBtn'],
    };
}

export function NodataPageItemResVoToJSON(json: any): NodataPageItemResVo {
    return NodataPageItemResVoToJSONTyped(json, false);
}

export function NodataPageItemResVoToJSONTyped(value?: NodataPageItemResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'warehouseId': value['warehouseId'],
        'warehouseName': value['warehouseName'],
        'imageUrl': value['imageUrl'],
        'userCode': value['userCode'],
        'userName': value['userName'],
        'trackingNumber': value['trackingNumber'],
        'locationNo': value['locationNo'],
        'quantity': value['quantity'],
        'carriageForward': value['carriageForward'],
        'coupangInboundCode': value['coupangInboundCode'],
        'orderCodes': value['orderCodes'],
        'operatorName': value['operatorName'],
        'nodataType': value['nodataType'],
        'nodataTypeName': value['nodataTypeName'],
        'nodataStatus': value['nodataStatus'],
        'nodataStatusName': value['nodataStatusName'],
        'returnFromCoupang': value['returnFromCoupang'],
        'createTime': value['createTime'],
        'discardTime': value['discardTime'],
        'discardBill': NodataDiscardBillResVoToJSON(value['discardBill']),
        'showDiscardBtn': value['showDiscardBtn'],
        'showDelBtn': value['showDelBtn'],
        'showMatchBtn': value['showMatchBtn'],
        'showUnMatchBtn': value['showUnMatchBtn'],
    };
}

